import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CotacaoService {

  constructor(
    private http: HttpClient
  ) { }

  salvarCotacao(parameters?: any) {
    return this.http.post(`${environment.protheus}/cotacao`, parameters);
  }
}
